import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, lastValueFrom } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class LabService {
  constructor(private http: HttpClient) {}

  public getToken(teamName: string): Observable<any> {
    return this.http.get(`${ConfigService.apiUrl}/lab-token/${teamName}`);
  }
  public getTokenAsync = async (teamName: string) => lastValueFrom(this.getToken(teamName));

}
